import { GraphModel } from '../../graph/graph.model';
import { DatasetModel } from '../model/dataset.model';
import { z } from 'zod/v3';
import { toast } from '@cotera/client/app/components/ui/toaster';
import { err, ok } from 'neverthrow';
import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '../../actions/framework';
import { Assert } from '@cotera/utilities';
import { DATASET_ACTION_GROUP } from './constants';

type Params = {};

export class RunDatasetChangesAction extends BaseAction<
  Params,
  { t: string; message?: string }[]
> {
  title = 'Run Dataset';
  inputSchema = z.object({});
  shortcut = ['ctrl', 'enter'];
  group = DATASET_ACTION_GROUP;
  icon = 'play';

  applicable(context: ApplicableContext): boolean {
    const isInScope =
      context.isInScope(GraphModel) &&
      context.hasTargetedModelOfType(DatasetModel);

    if (!isInScope) {
      return false;
    }

    const dataset = context.getInScopeModelOfType(DatasetModel)!;

    return (dataset.formState.snapshot()?.eraql.length ?? 0) > 0;
  }

  async execute(
    _: Params,
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string; message?: string }[]>> {
    const dataset = context.targetedModelOfType(DatasetModel);

    Assert.assert(dataset !== null, 'Dataset model not found');

    const result = dataset.compile();

    if (result.isErr()) {
      toast.error(JSON.stringify(result.error));
      return err([
        { t: result.error.t, message: JSON.stringify(result.error) },
      ]);
    }

    return ok({});
  }
}
